import React, { Component } from 'react';
import { View, Button, Modal, Spinner, Tip } from '../UIElements/All.js';
import { pts } from '../Managers/Utils.js';
import { retrieveUserDetails } from '../Managers/ReUpLoyaltyAPI';

import { Colors, ModalColors, ButtonColors } from '../Managers/ThemeManager';
import { isRetail } from '../Managers/Utils';
import { close } from '../Managers/LSLoyaltyAPI';
import Header from './Header'
import Loc from './Localization'
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class PageContainer extends Component 
{
  constructor(props) 
  {
    super(props);
    var state = {isUpdating:false};
    this.state = state;
  }

  setIsUpdating(isUpdating)
  {
    this.setState({isUpdating});
  }

  getModal()
  {
    return this._modal;
  }

  render() 
  {
    var self = this;
    return (
      <View style={{flex:-1, minHeight:'100%', minWidth:'100%', alignSelf:'stretch', backgroundColor:Colors.background1, justifyContent:'flex-start', flexDirection:'column'}}>
        <Header /> 
        {
          isRetail() && typeof this.props.urlInputs !== 'undefined' ?
            <View style={{flex:-1, flexDirection:'row'}}>
              <Button onPress={()=> {close(self.props.urlInputs)}} type={1} colors={ButtonColors} style={{alignSelf:'stretch', margin:14}}>
                <Loc locKey="BACK_TO_SALE_BUTTON"></Loc>
              </Button>
              <View style={{flex:1}} />
            </View>
          : null
        }
        {
          typeof this.props.urlInputs !== 'undefined' && !this.props.urlInputs.mobile ?
            <Tip title={this.props.tipTitle} body={this.props.tipBody} type={0} />
          : null
        }
        {
          typeof this.props.urlInputs !== 'undefined' && !this.props.urlInputs.mobile ?
            <Tip title={this.props.successTitle} body={this.props.successBody} type={1} />
          : null
        }
        {
          typeof this.props.urlInputs !== 'undefined' && typeof this.props.title !== 'undefined' && isRetail() && !this.props.urlInputs.mobile ?
            <View style={{ width:700, alignSelf:'center', marginTop:20, marginBottom:20, flexDirection:'column', flex:-1}}>
              <View style={{fontSize:18, marginBottom:8}}>
                <Loc locKey={this.props.title}></Loc> {typeof this.props.isRequired !== 'undefined' && this.props.isRequired === true ? (<View style={{fontSize: 18, color: 'gray', marginLeft: 8}}><Loc
	                locKey="REQUIRED_STR"></Loc></View>) : null}
              </View>
              <View style={{backgroundColor:Colors.text1, height:1, marginTop:1, flex:-1, alignSelf:'stretch'}} />
	            {
		            typeof this.props.description !== 'undefined' ?
			            <View style={{fontSize: 16, marginTop: 10}}>
				            <Loc locKey={this.props.description}></Loc>
			            </View>
			            :
			            null
	            }
            </View>
          : null
        }
        <View style={{flex:-1, alignSelf:'stretch', justifyContent:'flex-start', alignItems:'flex-start', flexDirection:'row', padding:8}}>
        	<View style={{flex:1}} />
        	<View style={{flex:-1, width:isRetail() ? 701 : 468, height:isRetail() ? -1 : 600, position:'relative', flexDirection:'column', justifyContent:'center'}}>
  	      	<View style={{flex:1, alignItems:'stretch', overflow:'hidden', alignSelf:'stretch', flexDirection:'column', justifyContent:'center'}}>
  		      {this.props.children}
  	      	</View>
  	      	{
  	      		this.state.isUpdating ?
  	      			<View style={{position:'absolute', top:0, left:0, bottom:0, right:0, alignSelf:'stretch', color:Colors.text1, justifyContent:'center', alignItems:'center', backgroundColor:Colors.background2LoadingBackground}}>
  	      				<Spinner color={ModalColors.border} />
  	      			</View>
  	      		: null
  	      	}
        	</View>
        	<View style={{flex:1}} />
        	<Modal ref={(a) => { this._modal = a; }} colors={ModalColors} />
        </View>
      </View>
    );
  }
}

